import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CategoryHeaderState } from './CategoryHeader.state';
import {
    CategoryHeaderWrapper,
    LeftSide,
    CategoryName,
    RightSide,
    Arrow,
    EditNameWrapper,
    InputWrapper,
    HeaderLabel,
    EditIconWrapper,
    ChevronWrapper,
    TrashIconWrapper,
    Chevron,
    ArrowsWrapper,
    SaveIconWrapper,
    CopyIconWrapper,
    SettingsDropdownWrapper,
} from './CategoryHeader.style';
import {
    CategorySettingsOptionType,
    CategorySettingsValueType,
    SettingsDropdown,
} from './SettingsDropdown/SettingsDropdown';
import { CategoryState } from 'src/domains/casino/state/AppCasino/live-games/Category.state';
import { LiveGamesState } from 'src/domains/casino/state/AppCasino/live-games/LiveGames.state';
import { useCommon } from 'src/AppState/Common';

export interface CategoryHeaderPropsType {
    category: CategoryState;
    liveGamesState: LiveGamesState;
}

export const CategoryHeader = observer('CategoryHeader', (props: CategoryHeaderPropsType) => {
    const common = useCommon();
    const { category } = props;
    const [state] = React.useState(() => new CategoryHeaderState(common, props));
    const { isEditingCategoryName, isGamesListEmpty, isCategoryActive, isNewCategory, isFixedCategory } = state;
    const chevronPosition = category.showGames === true && category.gameIds.length > 0 ? 'right' : 'down';

    return (
        <CategoryHeaderWrapper>
            <LeftSide>
                {state.isFixedCategory ? null : isEditingCategoryName ? (
                    <SaveIconWrapper
                        onClick={state.onSaveNewCategoryName}
                        dataTest='save-icon'
                    />
                ) : (
                    <EditIconWrapper
                        onClick={state.onEditCategoryName}
                        dataTest='edit-icon'
                    />
                )}
                <EditNameWrapper
                    isNameEdited={isFixedCategory === false}
                    onClick={state.onEditCategoryName}
                >
                    <CategoryName
                        isDisabled={isNewCategory === true && !isEditingCategoryName}
                        data-test='category-name'
                    >
                        {isEditingCategoryName ? (
                            <InputWrapper
                                formInputState={state.categoryInputState}
                                model={state.categoryInputModel}
                                autoFocus={true}
                            />
                        ) : (
                            <HeaderLabel>{state.categoryInputState.value}</HeaderLabel>
                        )}
                    </CategoryName>
                </EditNameWrapper>
            </LeftSide>
            {
                <RightSide>
                    <ArrowsWrapper>
                        <Arrow
                            position='down'
                            onClick={async (): Promise<void> => await state.onCategoryOrderDown(category.id)}
                            isDisabled={
                                category.isDownMovePossible === false ||
                                isNewCategory ||
                                isGamesListEmpty ||
                                isEditingCategoryName
                            }
                        />
                        <Arrow
                            position='up'
                            onClick={async (): Promise<void> => await state.onCategoryOrderUp(category.id)}
                            isDisabled={
                                category.isUpMovePossible === false ||
                                isNewCategory ||
                                isGamesListEmpty ||
                                isEditingCategoryName
                            }
                        />
                    </ArrowsWrapper>
                    <CopyIconWrapper onClick={state.onCopyUrlToClipboard} />
                    {isFixedCategory && isCategoryActive ? null : (
                        <SettingsDropdownWrapper data-test='settings-dropdown'>
                            <SettingsDropdown
                                optionsList={(): Array<CategorySettingsOptionType> => state.categorySettingsList}
                                selectedValues={(): Array<CategorySettingsValueType> => state.categorySettingsSelected}
                                onChangeCallback={state.onSettingsChange}
                                isDisabled={isEditingCategoryName || isGamesListEmpty}
                            />
                        </SettingsDropdownWrapper>
                    )}
                    {isFixedCategory ? null : (
                        <TrashIconWrapper
                            onClick={state.onRemoveCategory}
                            isNoCheckbox={isNewCategory || isGamesListEmpty || isEditingCategoryName}
                            dataTest='trash-icon'
                        />
                    )}
                </RightSide>
            }
            <ChevronWrapper>
                <Chevron
                    position={chevronPosition}
                    isDisabled={isEditingCategoryName || isGamesListEmpty}
                    onClick={category.toggleShowGames}
                />
            </ChevronWrapper>
        </CategoryHeaderWrapper>
    );
});
